import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FooterSectionComponent } from './footer-section/footer-section.component';
import { ToastComponent } from './toast/toast.component';
import { GeoModule } from '../../modules/geo/geo.module';
import { NavbarComponent } from '../../standalone-components/navbar/navbar.component';
import { PackageStatusComponent } from '../../standalone-components/package-status/package-status.component';
import { SlideToggleComponent } from '../../standalone-components/slide-toggle/slide-toggle.component';
import { CreditFormatterPipe } from '../shared/pipes/credit-formatter.pipe';
import { SvgIconComponent } from '../shared/svg-icon/svg-icon.component';

@NgModule({
  declarations: [
    FooterSectionComponent,
    ToastComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LocalizePipe,
    TranslateModule,
    NgSelectModule,
    GeoModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NavbarComponent,
    PackageStatusComponent,
    SlideToggleComponent,
    CreditFormatterPipe,
    SvgIconComponent,
  ],
  exports: [
    NavbarComponent,
    FooterSectionComponent,
    ToastComponent,
  ]
})
export class CoreModule {
}
